import { render } from "./edit-domain.vue?vue&type=template&id=652f2e64&ts=true&lang=pug"
import script from "./edit-domain.vue?vue&type=script&lang=ts&setup=true"
export * from "./edit-domain.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__